'use client'

import { useMemo } from 'react'
import type { Channel as TChatChannel } from 'stream-chat'
import { useChatContext } from 'stream-chat-react'

import { useChat } from '../contexts/chat-context'
import type { IChannelDetail } from '../types/channel-metadata'
import type { IChatUser } from '../types/chat-types'

export interface IActiveChannelMember {
  id: string
  user: IChatUser | null
}

export interface IActiveChannelSnapshot {
  channelCID: string | null
  channelDetail: IChannelDetail | null
  channelID: string | null
  channelType: string | null
  currentUserID: string | null
  isInitialized: boolean
  members: IActiveChannelMember[]
}

export const useActiveChannelInstance = (): TChatChannel | undefined => {
  const { channel } = useChatContext()
  return channel ?? undefined
}

export const useActiveChannelSnapshot = (): IActiveChannelSnapshot => {
  const channel = useActiveChannelInstance()
  const { currentUser } = useChat()

  return useMemo(() => {
    const members = Object.values(channel?.state?.members ?? {}).map((member) => ({
      id: member.user?.id || '',
      user: (member.user as IChatUser | undefined) ?? null
    }))

    return {
      channelCID: channel?.cid ?? null,
      channelDetail: (channel?.data?.channel_detail as IChannelDetail | undefined) ?? null,
      channelID: channel?.id ?? null,
      channelType: channel?.type ?? null,
      currentUserID: currentUser?.id ?? null,
      isInitialized: Boolean(channel?.initialized),
      members
    }
  }, [channel, currentUser?.id])
}
